import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/shipSailingRouteTpl/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/shipSailingRouteTpl',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/shipSailingRouteTpl',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/shipSailingRouteTpl/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/shipSailingRouteTpl',
    method: 'get',
    params: {
      id
    }
  })
}
